import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MF_EVENTS, } from "@/shared/microfrontend/interfaces/microFrontend";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Mail } from "lucide-react";
import { v4 as uuidv4 } from "uuid";
import { checkModeSpecificScopes, encodeParam, getFileExtension, getLatestUserDetails, pareseDataFromMsg, replaceAsteriskInAnchor, } from "@/shared/utils/helpers";
import { createClient } from "graphql-ws";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import useToastStore from "@/shared/zustand/toastStore";
import GmailLogo from "@/assets/icons/gmailLogo.svg";
import { HOST_MODES } from "@/constants";
import NotFoundAnimation from "@/assets/animations/notfoundAnimation.json";
import FilePreview from "@/components/FilePreview";
import { ChevronLeft, Eye, FileText, FileArchive, FileJson, FileMusic, FileType, File, FileImage, FileChartColumnIncreasing, FileSpreadsheet, FileVideo, Folder, } from "lucide-react";
import Lottie from "react-lottie-player";
import useDriveStore from "@/shared/zustand/driveModeStore";
import WelcomeScreen from "./welcomeScreen";
import { Tooltip } from "primereact/tooltip";
import { config } from "@/config";
import useAuthStore from "@/shared/zustand/authStore";
import LoadingAnimation from "@/widgets/driveMode/components/LoadingAnimation";
import InvalidScopes from "@/components/InvalidScopes";
const EmailModeTool = ({ 
// setIsHostLoaded,
setHostLoadedInfo, }) => {
    const mfApi = window.hostMicroFrontendApi;
    const { user } = useAuthStore();
    const showToast = useToastStore((state) => state.showToast);
    const [query, setQuery] = useState("");
    const [filesInEmail, setFilesInEmail] = useState([]);
    console.log("filesInEmail", filesInEmail);
    const [userEmail, setUserEmail] = useState("");
    const [isFilesFetched, setIsFilesFetched] = useState(false);
    const [isGraphqlError, setIsGraphQlError] = useState(false);
    const [showWelcomeScreen, setShowWelComeScreen] = useState(true);
    const [loading, setLoading] = useState(false); // Add this state to manage loading
    const scrollContainerRef = useRef(null);
    const [scrollPosition, setScrollPosition] = useState(0);
    const { selectedFiles, setSelectedFiles, addFile, clearSelectedFiles, removeFile, isFileSelected, } = useDriveStore();
    const [selectedPreviewFile, setSelectedPreviewFile] = useState(null);
    const [hasNeededScope, setHasNeededScope] = useState(null);
    const gmailScopes = "https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/cloud-platform";
    const handleSelectProject = (project, isSelected) => {
        if (isSelected) {
            addFile(project);
        }
        else {
            removeFile(project.id);
        }
    };
    function extractWaitMessage(inputString) {
        const prefix = "WaitMessage: ";
        const startIndex = inputString.indexOf(prefix);
        if (startIndex !== -1) {
            const extractedString = inputString.substring(startIndex + prefix?.length);
            return extractedString.replace("WaitMessage: ", "");
        }
        else {
            return "";
        }
    }
    //! AI Call
    const callEmailAgent = async (request) => {
        let client = null;
        // setShowWelComeScreen(false); // moved down
        try {
            const replyMessage = "";
            const currentContext = "";
            setIsGraphQlError(false);
            setIsFilesFetched(false);
            setHasNeededScope(null); // Reset the hasNeededScope state
            // setReplyMessage("");
            // const userQuery = request.message + `my email is ${request.userEmail}`;
            const userQuery = request.message;
            const messageId = request.messageId;
            const formattedQuery = `User Query: ${userQuery} Current Context: ${currentContext}`;
            let storedMessageForArtifact;
            let artifactstatus = "";
            const query = userQuery;
            const requestId = `requestId-${uuidv4()}`;
            const chatAssistantName = "devemailagent";
            // const chatAssistantName = "yashemailagent";
            // const chatAssistantName = "gmailagentassist";
            // console.log("PM assistant : ", chatAssistantName);
            const organizationName = "techolution";
            let latestUser = user;
            // console.log("printing before latest user", latestUser);
            if (user) {
                const updatedUser = await getLatestUserDetails(user);
                if (updatedUser) {
                    latestUser = updatedUser;
                }
                else {
                    // If we couldn't get updated user details, continue with existing user
                    console.warn("Could not refresh user details, using existing user data");
                }
            }
            if (latestUser?.provider.scope) {
                const hasScope = checkModeSpecificScopes(latestUser.provider.scope, gmailScopes);
                console.log("printing hasScope for gmail", hasScope, latestUser.provider.scope);
                if (!hasScope) {
                    setHasNeededScope("invalid");
                    return;
                }
                else {
                    setHasNeededScope("valid");
                }
            }
            else {
                showToast("warn", "Warning", "User doesnt have provider scopes");
                console.error("User doesnt have provider scopes , user details are", latestUser);
                return;
            }
            // console.log("printing after latest user", latestUser);
            client = await createClient({
                url: config.VITE_WEBSOCKET_URL ?? "",
            });
            const subscription = client.iterate({
                query: `subscription Subscription($guestSessionId: String!, $sessionId: String!, $name:String!, $organizationName:String!, $aiModel:String!, $prompt:String!, $userName:String!, $userEmailId:String!, $userId:String!, $requestId:String!,$replyMessage:String!,$customPrompt:String, $notificationSessionId:String,$images:String,$customMetaData:JSON) {
          chatStream(guestSessionId: $guestSessionId, sessionId: $sessionId, name:$name, organizationName:$organizationName, aiModel:$aiModel, prompt:$prompt, userName:$userName, userEmailId:$userEmailId, userId:$userId, requestId:$requestId, replyMessage:$replyMessage, customPrompt:$customPrompt, notificationSessionId:$notificationSessionId, images:$images, customMetaData: $customMetaData) {
            continueChatResult {
              isEnd
              thinking_break
              is_orchestrator
              is_agent
              responded_by
              header_message
              confidenceScore
              requestId
              replyMessage
              sessionId
              message {
                citations {
                  citation_number
                  title
                  url
                  description
                  metadata {
                    page_index
                  }
                }
                annotations {
                  citations {
                    citation_number
                    title
                    url
                    description
                    metadata {
                      page_index
                    }
                  }
                  text
                }
                citationDisplayType
                next_query_suggestions {
                  query
                }
                response_type
                content
                id
              }
              resourceId
            }
          }
        }`,
                variables: {
                    guestSessionId: window.location.pathname.split("/chat/")[1] || uuidv4(),
                    sessionId: `${organizationName}-${chatAssistantName}-${uuidv4()}`,
                    name: encodeParam(chatAssistantName),
                    organizationName: encodeParam("techolution"),
                    aiModel: encodeParam("claude-3.5-sonnet"),
                    chatPreviewId: encodeParam("techolution-cwdataintegrations-" + uuidv4()),
                    prompt: replyMessage === ""
                        ? encodeParam(formattedQuery)
                        : encodeParam("replyMessage" + "\n" + formattedQuery),
                    userName: encodeParam(latestUser?.provider.name),
                    userEmailId: encodeParam(latestUser?.email),
                    userId: encodeParam("0804b20a-2414-40c8-afd1-1bf0703e9d6e"),
                    requestId: encodeParam(requestId),
                    replyMessage: replyMessage,
                    // customPrompt: props?.generatedPrompt,
                    notificationSessionId: `chat-session-${uuidv4()}`,
                    images: JSON.stringify([]),
                    // customMetaData: {
                    //   user_access_token: getCookie("user-acess-token"),
                    // }
                    customMetaData: {
                        userName: latestUser?.provider.name,
                        userEmailId: latestUser?.email,
                        llm: "claude-3.5-sonnet",
                        user_access_token: {
                            token: latestUser?.provider.access_token,
                        },
                        user_refresh_token: {
                            token: latestUser?.provider.refresh_token,
                        },
                        operation: "read",
                    },
                },
            });
            let event;
            const accordianMessageArray = [];
            for await (event of subscription) {
                // setIsStreaming(true);
                // setRenderDone(false);
                setShowWelComeScreen(false);
                const getAssistantObj = (event, accordianMessageArray) => {
                    const streamedresponse = {
                        role: "assistant",
                        content: "",
                        id: uuidv4(),
                    };
                    //orchestrator is sending message, we initially set it as normal message
                    if (event.data.chatStream.continueChatResult.thinking_break === false &&
                        event.data.chatStream.continueChatResult.is_orchestrator === true &&
                        event.data.chatStream.continueChatResult.isEnd === false) {
                        streamedresponse.content = replaceAsteriskInAnchor(event.data.chatStream.continueChatResult.message.content)?.replace(/WaitMessage: /g, "");
                    }
                    //orchestrator is sending message and thinking break is there, we add it to accordian
                    if (event.data.chatStream.continueChatResult.thinking_break === true &&
                        event.data.chatStream.continueChatResult.is_orchestrator === true &&
                        event.data.chatStream.continueChatResult.isEnd === false) {
                        streamedresponse.content = "";
                        accordianMessageArray.push({
                            responsedata: event.data.chatStream.continueChatResult.message.content,
                            responseFrom: event.data.chatStream.continueChatResult.responded_by,
                            header_message: event.data.chatStream.continueChatResult.header_message,
                            finalResponseStatus: false,
                        });
                    }
                    //orchestrator replied with the final message, this is the final response, no need for accordian
                    if (event.data.chatStream.continueChatResult.thinking_break === false &&
                        event.data.chatStream.continueChatResult.is_orchestrator === true &&
                        event.data.chatStream.continueChatResult.isEnd === true) {
                        // console.log(
                        //   "Third if condition",
                        //   event.data.chatStream.continueChatResult
                        // );
                        streamedresponse.content = replaceAsteriskInAnchor(event.data.chatStream.continueChatResult.message.content)?.replace(/WaitMessage: /g, "");
                    }
                    //agent responded it will directly be shown in collapsed form
                    if (event.data.chatStream.continueChatResult.thinking_break === false &&
                        event.data.chatStream.continueChatResult.is_orchestrator ===
                            false &&
                        event.data.chatStream.continueChatResult.isEnd === false) {
                        // console.log("Fourth if condition", event.data);
                        accordianMessageArray = [
                            ...accordianMessageArray,
                            {
                                responsedata: event.data.chatStream.continueChatResult.message.content,
                                responseFrom: event.data.chatStream.continueChatResult.responded_by,
                                header_message: event.data.chatStream.continueChatResult.header_message,
                                finalResponseStatus: true,
                            },
                        ];
                    }
                    //final response from agent
                    if (event.data.chatStream.continueChatResult.thinking_break === true &&
                        event.data.chatStream.continueChatResult.is_orchestrator ===
                            false &&
                        event.data.chatStream.continueChatResult.isEnd === false) {
                        // console.log("Fifth if condition");
                        if (event.data.chatStream.continueChatResult.header_message ===
                            "Awesome! I've fetched your emails") {
                            const resObj = event.data.chatStream.continueChatResult.message.content;
                            let resJson = {
                                emails: [],
                            };
                            try {
                                // resJson = JSON.parse(
                                //   event.data.chatStream.continueChatResult.message.content
                                // );
                                resJson = pareseDataFromMsg(event.data.chatStream.continueChatResult.message.content);
                                if (Object.keys(resJson).length === 0 || "emails" in resJson === false || Array.isArray(resJson.emails) === false || resJson.emails.length === 0) {
                                    resJson = {
                                        emails: [],
                                    };
                                    throw new Error("No emails found in the response. Please try again." +
                                        " Response from agent: " + event.data.chatStream.continueChatResult.message.content);
                                }
                            }
                            catch {
                                console.log("Could not parse Json!");
                                resJson = {
                                    emails: [],
                                };
                            }
                            console.log("printing resJson", resJson);
                            // commenting the below for noe
                            setFilesInEmail(resJson.emails);
                            setIsFilesFetched(true);
                            const statusMsgData = {
                                artifactData: {
                                    id: uuidv4(),
                                    artifactTitle: `Artifact: ${HOST_MODES["Email Mode"]}`,
                                    artifactData: resJson.emails,
                                    modeName: HOST_MODES["Email Mode"],
                                },
                            };
                            const statusMessage = {
                                messageType: "success",
                                message: "",
                                data: statusMsgData,
                                messageId: uuidv4(),
                                time: new Date(),
                                isReadyToPersist: true,
                                modeName: HOST_MODES["Email Mode"], //  have to change this
                            };
                            mfApi.dispatch(MF_EVENTS.PROCESS_STATUS, statusMessage);
                            // storedMessageForArtifact = statusMessage;
                            // storedMessageForArtifact;
                            // artifactstatus = "true";
                        }
                        accordianMessageArray.push({
                            responsedata: event.data.chatStream.continueChatResult.message.content,
                            responseFrom: event.data.chatStream.continueChatResult.responded_by,
                            header_message: event.data.chatStream.continueChatResult.header_message,
                            finalResponseStatus: false,
                        });
                    }
                    const annotations = event?.data?.chatStream?.continueChatResult?.message?.annotations;
                    let assistantObj = {
                        role: "assistant",
                        content: streamedresponse.content,
                        orchestratorAndAgentsMessages: accordianMessageArray,
                        time: new Date(),
                        requestId: event.data.chatStream.continueChatResult.requestId ?? "",
                        citations: event.data.chatStream.continueChatResult.message.citations,
                        annotations: annotations,
                        resourceId: event.data.chatStream.continueChatResult.resourceId,
                        citationDisplayType: event.data.chatStream.continueChatResult.message
                            .citationDisplayType ?? "",
                    };
                    if (annotations) {
                        for (let index = 0; index < annotations?.length; index++) {
                            const annotation = annotations[index];
                            assistantObj = {
                                ...assistantObj,
                                content: assistantObj?.content?.replace(annotation?.text, annotation?.text + `<sup>${index}</sup>`),
                            };
                        }
                    }
                    return assistantObj;
                };
                let streamedresponse = {
                    role: "assistant",
                    content: "",
                    id: uuidv4(),
                };
                if (event.data.chatStream.continueChatResult.message.content.includes("WaitMessage: ")) {
                    streamedresponse.content = extractWaitMessage(event.data.chatStream.continueChatResult.message.content + "\n\n");
                    // !dont know about this case for now
                    //@ts-ignore
                    const thinkingStatusMessage = {
                        messageType: "loading",
                        message: "",
                        messageId: requestId,
                        time: new Date(),
                        isThinking: true,
                        thinkingResponse: streamedresponse,
                        isStreamEnd: event?.data?.chatStream?.continueChatResult?.isEnd || false,
                    };
                    mfApi.dispatch(MF_EVENTS.PROCESS_STATUS, thinkingStatusMessage);
                }
                else {
                    streamedresponse.content = replaceAsteriskInAnchor(event.data.chatStream.continueChatResult.message.content)?.replace(/WaitMessage: /g, "");
                    const assistantObject = getAssistantObj(event, accordianMessageArray);
                    // thinking part
                    // console.log("assistantObject->>>>>", assistantObject);
                    //TODO status update from here
                    const thinkingStatusMessage = {
                        messageType: "loading",
                        message: "",
                        messageId: assistantObject.requestId,
                        time: new Date(),
                        isThinking: true,
                        thinkingResponse: assistantObject,
                        isStreamEnd: event?.data?.chatStream?.continueChatResult?.isEnd || false,
                    };
                    mfApi.dispatch(MF_EVENTS.PROCESS_STATUS, thinkingStatusMessage);
                    if (event?.data?.chatStream?.continueChatResult?.isEnd) {
                        try {
                            const parsedWidgetTypeData = JSON.parse(event?.data?.chatStream?.continueChatResult?.message?.content);
                        }
                        catch (error) {
                            console.log(error, "error");
                        }
                        // if (artifactstatus !== "") {
                        // mfApi.dispatch(
                        //   MF_EVENTS.PROCESS_STATUS,
                        //   storedMessageForArtifact
                        // );
                        //   artifactstatus = "";
                        // }
                        break; // to end the grapql call
                    }
                }
            }
        }
        catch (error) {
            console.error("Error in callEmailAgent:", error.message);
            setIsGraphQlError(true);
            setIsFilesFetched(true);
            // You might want to dispatch an error status message here
            const errorStatusMessage = {
                messageType: "error",
                message: "Failed to process your request. " + error.message || "",
                messageId: uuidv4(),
                time: new Date(),
                isReadyToPersist: true,
            };
            mfApi.dispatch(MF_EVENTS.PROCESS_STATUS, errorStatusMessage);
        }
        finally {
            // Cleanup WebSocket connection
            if (client) {
                try {
                    const socket = client?.socket;
                    await client.dispose();
                    if (socket) {
                        const socketState = ["CONNECTING", "OPEN", "CLOSING", "CLOSED"][socket.readyState] ||
                            "UNKNOWN";
                        console.log(`WebSocket state after dispose: ${socketState} (${socket.readyState})`);
                        if (socket.readyState === WebSocket.CLOSED) {
                            console.log("WebSocket connection closed successfully");
                        }
                        else {
                            console.warn(`WebSocket not fully closed. Current state: ${socketState}`);
                        }
                    }
                    else {
                        console.log("WebSocket connection disposal completed");
                    }
                }
                catch (error) {
                    console.error("Error during WebSocket cleanup:", error);
                }
            }
        }
    };
    useEffect(() => {
        const handleRemoteLoad = () => {
            setHostLoadedInfo({
                modeName: HOST_MODES["Email Mode"],
                isLoaded: true,
            });
            // old code
            // setIsHostLoaded?.(true);
            if (mfApi && "setRemoteLoaded" in mfApi) {
                mfApi.setRemoteLoaded(true);
            }
        };
        const handleRemoteUnload = () => {
            setHostLoadedInfo({
                modeName: HOST_MODES["Email Mode"],
                isLoaded: false,
            });
            // old code
            // setIsHostLoaded?.(false);
            if (mfApi && "setRemoteLoaded" in mfApi) {
                mfApi.setRemoteLoaded(false);
            }
        };
        handleRemoteLoad();
        return () => {
            handleRemoteUnload();
        };
    }, [mfApi, setHostLoadedInfo]);
    useEffect(() => {
        if (!mfApi) {
            console.warn("Remote MicroFrontend API not initialized");
            return;
        }
        const unsubscribers = [];
        //NOTE: MAKE SURE EVENT NAME IS SAME AS THE `modeName` WHICH IS SET IN THE intialModeList.
        const unsubscribe = mfApi.subscribe(HOST_MODES["Email Mode"], (request) => {
            console.log("Email Tool Host Mode received request:", request);
            setUserEmail(request.userEmail ?? "");
            setQuery(request.message);
            //call email agent
            callEmailAgent(request);
        });
        unsubscribers.push(unsubscribe);
        const getArtifaceDataUnsubscribe = mfApi.subscribe(MF_EVENTS.SEND_ARTIFACT_DATA, async (request) => {
            console.log("Drive Tool Host Mode received SEND_ARTIFACT_DATA request:", request);
            clearSelectedFiles();
            setShowWelComeScreen(false);
            setFilesInEmail(request.artifactData);
            setIsFilesFetched(true);
        });
        unsubscribers.push(getArtifaceDataUnsubscribe);
        return () => {
            unsubscribers.forEach((unsubscribe) => unsubscribe());
        };
    }, []);
    const handleAddToProject = () => {
        if (mfApi) {
            const payload = {
                addToProject: true, //!modeFullScreen,
                modeName: HOST_MODES["Email Mode"], //  have to change this
            };
            mfApi.dispatch(MF_EVENTS.ADD_TO_PROJECT, payload);
        }
    };
    const count = 100; // Number of times to repeat
    const [searchTerm, setSearchTerm] = useState("");
    const [sortOrder, setSortOrder] = useState("");
    const sortOptions = [
        { label: "Name: A-Z", value: "asc" },
        { label: "Name: Z-A", value: "desc" },
    ];
    // Filter and sort logic
    const filteredAndSortedFiles = useMemo(() => {
        const lowerSearchTerm = searchTerm?.toLowerCase();
        const filteredFiles = filesInEmail?.filter((file) => {
            return file?.title?.toLowerCase()?.includes(lowerSearchTerm);
        });
        return filteredFiles?.sort((a, b) => {
            switch (sortOrder) {
                case "asc":
                    return a?.title?.localeCompare(b?.title); // A-Z
                case "desc":
                    return b?.title?.localeCompare(a?.title); // Z-A
                default:
                    return 0;
            }
        });
    }, [filesInEmail, searchTerm, sortOrder]);
    // console.log("filteredAndSortedFiles", filteredAndSortedFiles);
    const handleFileClick = (e, project) => {
        if (scrollContainerRef.current) {
            setScrollPosition(scrollContainerRef.current.scrollTop);
        }
        const target = e.target;
        const isFileIconClick = target.closest(".file-icon");
        if (isFileIconClick) {
            setSelectedPreviewFile(project);
        }
        else {
            // commenting for now
            // const isSelected = isFileSelected(project.id);
            // if (!project.capabilities.canDownload) {
            //   showToast(
            //     "warn",
            //     "Warn",
            //     "Cannot select file: Download permission not available"
            //   );
            //   return;
            // }
            // handleSelectProject(project, !isSelected);
        }
    };
    useEffect(() => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = scrollPosition;
        }
    }, [scrollPosition, selectedFiles]);
    const getIconByExtension = (extension, mimeType) => {
        switch (extension) {
            // Spreadsheet-related extensions
            case ".xlsx":
            case ".xls":
            case ".csv":
            case ".gsheet":
                return _jsx(FileSpreadsheet, { size: 24, color: "#86AFAF" });
            // Presentation-related extensions
            case ".pptx":
            case ".ppt":
            case ".gslides":
                return _jsx(FileChartColumnIncreasing, { size: 24, color: "#86AFAF" });
            // Document-related extensions
            case ".doc":
            case ".docx":
            case ".gdoc":
                return _jsx(FileText, { size: 24, color: "#86AFAF" });
            // Image-related extensions
            case ".png":
            case ".jpg":
            case ".jpeg":
            case ".gif":
                return _jsx(FileImage, { size: 24, color: "#86AFAF" });
            // Video-related extensions
            case ".mp4":
            case ".mov":
            case ".avi":
                return _jsx(FileVideo, { size: 24, color: "#86AFAF" });
            // Audio-related extensions
            case ".mp3":
            case ".wav":
            case ".aac":
                return _jsx(FileMusic, { size: 24, color: "#86AFAF" });
            // PDF
            case ".pdf":
                return _jsx(FileText, { size: 24, color: "#86AFAF" });
            // Code-related extensions
            case ".json":
            case ".js":
            case ".css":
            case ".html":
            case ".xml":
            case ".yaml":
            case ".yml":
            case ".md":
                return _jsx(FileJson, { size: 24, color: "#86AFAF" });
            // Archive-related extensions
            case ".zip":
            case ".tar":
            case ".gz":
            case ".bz2":
            case ".7z":
            case ".rar":
                return _jsx(FileArchive, { size: 24, color: "#86AFAF" });
            // Text files
            case ".txt":
                return _jsx(FileType, { size: 24, color: "#86AFAF" });
            // Folder (no extension)
            case "folder":
                if (mimeType === "application/vnd.google-apps.folder") {
                    return _jsx(Folder, { size: 24, color: "#86AFAF" });
                }
                break;
            // Default for unknown types (e.g., .bin)
            default:
                return _jsx(File, { size: 24, color: "#86AFAF" });
        }
        // Fallback based on MIME type prefix if no specific extension match
        if (mimeType.startsWith("image/")) {
            return _jsx(FileImage, { size: 24, color: "#86AFAF" });
        }
        else if (mimeType.startsWith("video/")) {
            return _jsx(FileVideo, { size: 24, color: "#86AFAF" });
        }
        else if (mimeType.startsWith("audio/")) {
            return _jsx(FileMusic, { size: 24, color: "#86AFAF" });
        }
        return _jsx(File, { size: 24, color: "#86AFAF" });
    };
    const renderFileIcon = (mimeType) => {
        // Get the extension using the helper function
        const extension = getFileExtension(mimeType);
        // Return the icon based on the extension and MIME type
        return getIconByExtension(extension, mimeType);
    };
    const getFileTypeLabel = (mimeType) => {
        const extension = getFileExtension(mimeType);
        // console.log("printing extension", extension, " mimeType", mimeType);
        switch (extension) {
            // Spreadsheet-related extensions
            case ".xlsx":
            case ".xls":
            case ".csv":
            case ".gsheet":
                return "Spreadsheet";
            // Presentation-related extensions
            case ".pptx":
            case ".ppt":
            case ".gslides":
                return "Presentation";
            // Document-related extensions
            case ".doc":
            case ".docx":
            case ".gdoc":
                return "Doc";
            // Image-related extensions
            case ".png":
            case ".jpg":
            case ".jpeg":
            case ".gif":
                return "Image";
            // Video-related extensions
            case ".mp4":
            case ".mov":
            case ".avi":
                return "Video";
            // Audio-related extensions
            case ".mp3":
            case ".wav":
            case ".aac":
                return "Audio";
            // PDF
            case ".pdf":
                return "PDF";
            // Code-related extensions
            case ".json":
            case ".js":
            case ".css":
            case ".html":
            case ".xml":
            case ".yaml":
            case ".yml":
            case ".md":
                return "Code";
            // Archive-related extensions
            case ".zip":
            case ".tar":
            case ".gz":
            case ".bz2":
            case ".7z":
            case ".rar":
                return "Archive";
            // Text files
            case ".txt":
                return "Text";
            // Folder (no extension)
            case "folder":
                if (mimeType === "application/vnd.google-apps.folder") {
                    return "Folder";
                }
                break;
            // Default for unknown types (e.g., .bin)
            default:
                return "File";
        }
        // Fallback based on MIME type prefix if no specific extension match
        if (mimeType.startsWith("image/")) {
            return "Image";
        }
        else if (mimeType.startsWith("video/")) {
            return "Video";
        }
        else if (mimeType.startsWith("audio/")) {
            return "Audio";
        }
        return "File";
    };
    const formatFileSize = (bytesStr) => {
        // Convert string to number, default to 0 if invalid
        const bytes = parseInt(bytesStr, 10) || 0;
        // Define conversion constants
        const KB = 1024;
        const MB = KB * 1024;
        const GB = MB * 1024;
        // Determine the appropriate unit and convert
        if (bytes >= GB) {
            const sizeInGB = bytes / GB;
            return `${sizeInGB.toFixed(2)} GB`;
        }
        else if (bytes >= MB) {
            const sizeInMB = bytes / MB;
            return `${sizeInMB.toFixed(2)} MB`;
        }
        else if (bytes >= KB) {
            const sizeInKB = bytes / KB;
            return `${sizeInKB.toFixed(2)} KB`;
        }
        else {
            return `${bytes} Bytes`;
        }
    };
    const formatCreatedTime = (createdTime) => {
        const parts = createdTime.split(" ");
        const datePart = parts[0];
        return datePart?.replace(/:/g, "/");
        // const timePart = parts[1].split(":");
        // const truncatedTimestamp = `${datePart} ${timePart[0]}:${timePart[1]}`;
        // console.log(truncatedTimestamp); // Output: "01:04:2025 11:05"
        // return truncatedTimestamp;
    };
    const DriveCard = ({ project, onSelect, isSelected, }) => {
        const handleClick = () => {
            onSelect(project, !isSelected); // toggle selection
        };
        return (_jsx("div", { 
            // title={`Open ${project.name}`}
            onClick: (e) => handleFileClick(e, project), className: `min-w-[350px] grid grid-cols-1 px-6 py-4 rounded-[8px] border ${isSelected
                ? "bg-[#0D9488]/5 border-[#0D9488]/20"
                : "border-[#0D9488]/20"} cursor-pointer shadow-project-card flex flex-col justify-between transform transition-transform duration-200 hover:-translate-y-1 relative`, style: {
                border: isSelected ? "1px solid #008080" : "1px solid #D1D5DB",
            }, role: "button", tabIndex: 0, children: _jsxs("div", { className: "w-full flex justify-between overflow-x-hidden items-center", children: [_jsxs("div", { className: "w-full flex overflow-x-hidden items-center gap-x-4", children: [_jsx("div", { className: "file-icon cursor-pointer w-12 h-12 \n                rounded-[6px] \n                flex items-center justify-center bg-[#0D9488]/10 transition-all", title: "Click to preview", children: _jsx(Mail, { size: 24, color: "#86AFAF" }) }), _jsxs("div", { "data-pr-tooltip": project?.title, "data-pr-position": "top", className: " toolTipBtn flex flex-col gap-y-1 min-w-0 ", children: [_jsx("h3", { className: "text-base 2xl:text-lg font-medium text-[#101828] leading-5 font-content", children: project.title?.length > 80
                                            ? project.title?.slice(0, 80) + "..."
                                            : project?.title }), _jsx("div", { className: " flex gap-x-1 items-center", children: _jsxs("div", { className: "text-[#6B7280] text-sm flex items-center", children: [_jsxs("p", { className: " mx-1 ", children: [formatCreatedTime(project.created_time), "  |  "] }), "Email from", " ", _jsx("p", { className: " ml-1 font-semibold", children: project?.sender })] }) })] }), _jsx(Tooltip, { target: ".toolTipBtn" })] }), _jsx(Button, { icon: _jsx(Eye, { size: 20, color: "#5928ed" }), className: "file-icon ml-auto cursor-pointer" })] }) }, project.title));
    };
    if (hasNeededScope && hasNeededScope === "invalid") {
        return _jsx(InvalidScopes, { scopeName: "Google Mail" });
    }
    if (isGraphqlError === true && showWelcomeScreen === false) {
        return (_jsxs("div", { className: "mt-20 flex flex-col justify-center items-center", children: [_jsx(Lottie, { animationData: NotFoundAnimation, loop: true, play: true, className: "w-full md:w-1/2 mx-auto" }), _jsx("p", { className: "italic text-red-500", children: "There is some error occurred, please try again..." })] }));
    }
    if (showWelcomeScreen) {
        return _jsx(WelcomeScreen, {});
    }
    if (isFilesFetched === false &&
        isGraphqlError === false &&
        showWelcomeScreen === false) {
        return _jsx(LoadingAnimation, { textToBeDisplayed: "Processing your emails" });
    }
    return (_jsx("div", { className: "w-full h-full p-4", children: selectedPreviewFile ? (_jsxs("div", { className: "w-full h-full flex flex-col", children: [_jsxs("div", { className: "flex-shrink-0 flex items-center justify-between", children: [_jsx("h2", { className: "text-[#344054] text-3xl h-lg:text-4xl font-semibold font-heading", children: selectedPreviewFile?.title &&
                                selectedPreviewFile?.title?.length > 50
                                ? selectedPreviewFile?.title?.slice(0, 50) + "..."
                                : selectedPreviewFile?.title }), _jsx(Button, { icon: _jsx(ChevronLeft, { size: 16, color: "#5928ed" }), label: "Go Back", text: true, className: "text-[#374151] text-sm ml-auto px-4 py-2 rounded-[6px] flex items-center gap-2 border border-[#D1D5DB]", onClick: () => setSelectedPreviewFile(null) })] }), _jsx("div", { className: "w-full h-[calc(100%-40px)]", children: _jsx(FilePreview, { visible: true, onHide: () => setSelectedPreviewFile(null), type: "direct", 
                        // url={`https://drive.google.com/file/d/${selectedPreviewFile.id}/preview`}
                        url: selectedPreviewFile?.body_html?.length > 0
                            ? ""
                            : selectedPreviewFile?.link, directData: selectedPreviewFile.body_html }) })] })) : (_jsx("div", { className: " w-full h-full flex flex-col gap-y-4", children: filteredAndSortedFiles ? (_jsxs(_Fragment, { children: [_jsx("div", { className: "w-full flex flex-col   items-center justify-center", children: filesInEmail?.length > 0 && (_jsx("div", { className: "flex w-full items-center justify-between", children: _jsxs("div", { className: "text-3xl h-lg:text-4xl font-semibold font-heading flex items-center justify-center gap-2  ", children: [_jsx("p", { className: " text-[#9CA3AF]", children: "Emails Found in" }), _jsx(GmailLogo, {}), _jsx("p", { className: " text-[#344054]", children: "Google Mail" }), _jsx("p", { className: "text-sm", children: " Powered by Agentspace" })] }) })) }), _jsxs("div", { className: "flex flex-col gap-y-4 h-[calc(100%-60px)]", children: [_jsx("div", { className: "flex justify-between items-center w-full", children: _jsxs("div", { className: "flex gap-4 items-center", children: [_jsx(InputText, { disabled: filesInEmail?.length < 1, value: searchTerm, onChange: (e) => setSearchTerm(e.target.value), placeholder: "Search file...", className: "w-[260px] h-9 border border-[#D1D5DB] px-3 py-3 rounded-[6px] text-sm" }), _jsx(Dropdown, { disabled: filesInEmail?.length < 1 ||
                                                filteredAndSortedFiles?.length < 1, value: sortOrder, options: sortOptions, onChange: (e) => setSortOrder(e.value), placeholder: "Sort by", className: "custom-header-dropdown w-[200px] h-full border border-[#D1D5DB] rounded-[6px] text-sm", panelClassName: "shadow-md border border-[#d1d5db] rounded-[8px] mt-1" })] }) }), _jsx("div", { ref: scrollContainerRef, className: "w-full h-[calc(100%-100px)] p-5 rounded-[8px] border border-[#d1d5db] flex flex-col  gap-4 overflow-y-auto", children: filteredAndSortedFiles?.length > 0 ? (filteredAndSortedFiles?.map((file) => {
                                    const isSelected = selectedFiles?.some((p) => p?.id === file?.id);
                                    return (_jsx(DriveCard, { project: file, 
                                        // onSelect={handleSelectProject} // Pass the selection handler
                                        onSelect: () => { }, isSelected: isSelected }, uuidv4()));
                                })) : (_jsx("p", { className: "w-full my-auto text-center", children: "No emails found" })) })] })] })) : (_jsxs("div", { className: "w-full flex-1 flex flex-col gap-y-4", children: [_jsx(Lottie, { animationData: NotFoundAnimation, loop: true, play: true, className: "w-full md:w-1/2 mx-auto" }), _jsx("div", { className: " text-center p-4", children: "No data found" })] })) })) }));
};
export default EmailModeTool;
